<template>
  <div class="card-box-overview rounded-24 bg-2 p-6">
    <h3 v-if="!useSlot" class="mb-3 text-semibold text-dark fs-18">
      {{ title }}
    </h3>
    <slot v-else />
    <div class="d-flex">
      <div v-if="loading" class="text-center py-9">
        <b-spinner variant="primary" />
      </div>
      <div
        v-else
        v-for="(item, index) in options"
        :key="`card-info-${index}`"
        class="d-flex"
      >
        <div class="value-card">
          <small class="text-dark mb-1">{{ item.name }}</small>
          <div class="d-flex align-items-start">
            <h6
              :class="
                `${item.class} ${
                  hideValues && item.blur ? 'blur' : ''
                } mr-2 text-semibold`
              "
            >
              {{ item.value }}
            </h6>
            <div v-if="item.rightInfo" :class="`${item.rightInfo.class} pb-2`">
              <i v-if="item.rightInfo.icon" :class="`${item.rightInfo.icon}`" />
              <small :class="`${hideValues && item.blur ? 'blur' : ''} mr-2`">
                {{ item.rightInfo.value }}
              </small>
            </div>
          </div>
          <small
            v-if="item.secondaryValue"
            :class="`${item.class} ${hideValues && item.blur ? 'blur' : ''}`"
          >
            {{ item.secondaryValue }}
          </small>
        </div>
        <div v-if="index < options.length - 1" class="divisor mx-5"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    externalLoading: {
      type: Boolean,
      default: false
    },
    useSlot: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    hideValues: Boolean
  },
  data() {
    return {
      loading: false
    };
  },
  watch: {
    externalLoading(val) {
      this.loading = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.card-box-overview {
  height: 100%;
  .value-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    // &:not(:last-child),
    // &:not(:first-child) {
    //   margin: 8px 0;
    // }
  }

  .divisor {
    width: 1px;
    height: 100%;
    background: var(--dark-10);
  }

  button {
    min-height: 9px;
    i {
      font-size: 10px;
      color: #928f98;

      @media screen and (max-width: 991px) {
        font-size: 14px;
      }
    }
  }

  .blur {
    will-change: filter;
    filter: blur(0.4rem);
  }
}
</style>
